import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { SerializedSocialChannel } from '../types';
import { channelConnectPartnerName } from './channelConnectRoute';
import { withBrandWord } from '../../components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Promote pillar; each part uses its own slice of it */
import styles from './PromoteChannels.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ChannelPartnerNoteProps {
  channel: SerializedSocialChannel;
}

/**
 * The note next to Connect when the server sends the login to a posting partner. The name comes
 * from the server (`connectPartnerName`); the web has no list of partners.
 */
const ChannelPartnerNoteComponent: React.FC<ChannelPartnerNoteProps> = ({ channel }) => {
  const intl = useIntl();
  const partner = channelConnectPartnerName(channel);
  if (partner === null) {
    return null;
  }
  return (
    <p className={styles.quietNote} data-testid="channel-partner-note">
      {withBrandWord(
        intl.formatMessage(
          {
            id: 'app.sml.promote.channels.partnerNote',
            defaultMessage: 'You sign in through {partner}, our posting partner. MUSIC24 never sees your password.',
          },
          { partner }
        )
      )}
    </p>
  );
};

export const ChannelPartnerNote = TypedMemo(ChannelPartnerNoteComponent);
